<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title">Analisar Processo de Pagamento</slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="$emit('onCloseReport')" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <!-- Remoção a pedido do everton em 03/05/21 -->
        <!-- <v-row>
          <v-col>
            <h1>Anexos</h1>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-data-table
              :headers="headersAnexos"
              :items="report.anexos"
              class="elevation-1"
              hide-default-footer
              disable-pagination
            >
              <template v-slot:item.download="{ item }">
                <v-btn
                  outlined
                  color="primary"
                  class="ml-3"
                  @click="downloadAnexoProcessoPagamento(item)"
                >
                  <span>Download</span>
                </v-btn>
              </template>

              <template slot="no-data">
                <span>
                  Nenhum anexo retornado
                </span>
              </template>
            </v-data-table>
          </v-col>
        </v-row> -->

        <v-row>
          <v-col>
            <h1>Relatórios</h1>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
              label="Número do relatório"
              name="numero"
              type="number"
              required
              v-model="report.numero"
              :disabled="report.statusId !== 1 ? false : true"
              filled
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              label="Total de relatórios"
              name="total"
              type="number"
              required
              v-model="report.total"
              :disabled="report.statusId !== 1 ? false : true"
              filled
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              label="Código da Contratação"
              name="codigocontratacao"
              type="text"
              required
              v-model="report.codigoContratacao"
              :disabled="report.statusId !== 1 ? false : true"
              filled
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              label="Período de Realização (dd/mm/yyyy - dd/mm/yyyy)"
              name="realizacao"
              type="text"
              v-mask="'##/##/#### - ##/##/####'"
              required
              v-model="report.periodoRealizacao"
              :disabled="report.statusId !== 1 ? false : true"
              filled
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-data-table
              :headers="headers"
              :items="report.relatorioPagamento"
              item-key="relatorioPagamentoId"
              class="elevation-1"
              hide-default-footer
              disable-pagination
              :single-expand="true"
              show-expand
            >
              <template v-slot:item.relatorio.criacao="{ item }">
                {{ item.relatorio.criacao | moment("DD/MM/YYYY") }}
              </template>

              <template slot="no-data">
                <span> Nenhum relatório retornado </span>
              </template>

              <template v-slot:expanded-item="{ item }">
                <td colspan="5" id="report-expanded">
                  <v-tabs vertical>
                    <v-tab>
                      <v-icon left>mdi-file-chart</v-icon>
                      Relatório
                    </v-tab>
                    <v-tab>
                      <v-icon left>mdi-account-multiple-plus</v-icon>
                      Convidados
                    </v-tab>
                    <v-tab>
                      <v-icon left>mdi-attachment</v-icon>
                      Anexos
                    </v-tab>
                    <v-tab>
                      <v-icon left>mdi-calendar-check-outline</v-icon>
                      {{ isAT ? "Atividades" : "Tarefas" }}
                    </v-tab>
                    <v-tab>
                      <v-icon left>mdi-android-messages</v-icon>
                      Observações
                    </v-tab>

                    <v-tab-item>
                      <v-col>
                        <v-textarea
                          v-model="item.relatorio.descricao"
                          readonly
                        ></v-textarea>
                      </v-col>
                    </v-tab-item>
                    <v-tab-item>
                      <v-data-table
                        :headers="headersConvidados"
                        :items="item.relatorio.convidados"
                        class="elevation-1"
                        hide-default-footer
                        disable-pagination
                      >
                        <template v-slot:item.presente="{ item }">
                          <v-checkbox
                            v-model="item.presente"
                            :id="'membro' + item.membroId"
                            color="primary"
                            disabled
                          >
                          </v-checkbox>
                        </template>

                        <template slot="no-data">
                          <span> Nenhum convidado retornado </span>
                        </template>
                      </v-data-table>
                    </v-tab-item>
                    <v-tab-item>
                      <v-data-table
                        :headers="headersAnexos"
                        :items="item.relatorio.anexos"
                        class="elevation-1"
                        hide-default-footer
                        disable-pagination
                      >
                        <template v-slot:item.download="{ item }">
                          <v-btn
                            outlined
                            color="primary"
                            class="ml-3"
                            @click="downloadAnexo(item)"
                          >
                            <span>Download</span>
                          </v-btn>
                        </template>

                        <template slot="no-data">
                          <span> Nenhum anexo retornado </span>
                        </template>
                      </v-data-table>
                    </v-tab-item>
                    <v-tab-item>
                      <v-data-table
                        :headers="headersTarefas"
                        :items="item.relatorio.tarefas"
                        class="elevation-1"
                        hide-default-footer
                        disable-pagination
                      >
                        <template v-slot:item.cumprida="{ item }">
                          <v-checkbox
                            v-model="item.cumprida"
                            :id="'cumprida' + item.tarefaId"
                            color="primary"
                            disabled
                          >
                          </v-checkbox>
                        </template>
                        <template
                          v-slot:item.tarefa.municipioTarefa.municipioEvidencias="{
                            item,
                          }"
                        >
                          <span
                            v-for="evidencia in item.municipioTarefa
                              .municipioEvidencias"
                            :key="evidencia.municipioEvidenciaId"
                          >
                            {{ evidencia.nome }} |
                          </span>
                        </template>

                        <template slot="no-data">
                          <span> Nenhuma tarefa retornada </span>
                        </template>
                      </v-data-table>
                    </v-tab-item>
                    <v-tab-item>
                      <v-col>
                        <v-textarea
                          v-model="item.relatorio.observacoes"
                          readonly
                        ></v-textarea>
                      </v-col>
                    </v-tab-item>
                  </v-tabs>
                </td>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <h2>Relatórios administrativos</h2>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-data-table
              :headers="headersAdministrativeReport"
              :items="report.relatorioAdministrativoPagamento"
              item-key="relatorioAdministrativoPagamentoId"
              class="elevation-1"
              hide-default-footer
              disable-pagination
            >
              <template v-slot:item.relatorioAdministrativo.criacao="{ item }">
                {{
                  item.relatorioAdministrativo.criacao | moment("DD/MM/YYYY")
                }}
              </template>

              <template slot="no-data">
                <span> Nenhum relatório administrativo retornado </span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              label="Motivo da rejeição"
              v-model="report.observacoes"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          color="error"
          outlined
          text
          @click="$emit('onCloseReport', false)"
          >Fechar</v-btn
        >
        <v-btn
          color="info"
          outlined
          text
          @click="save(1)"
          v-if="isAdmin && report.statusId !== 1"
          >Aprovar</v-btn
        >
        <v-btn
          color="info"
          outlined
          text
          @click="save(2)"
          v-if="isAdmin && report.statusId === 0"
          >Rejeitar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { paymentReportManagementAPI } from "@/modules/payment-management";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppModalAnalyse",
  props: {
    dialog: { type: Boolean, default: false },
    payload: { type: Object, required: true },
  },
  data() {
    return {
      headersReport: [
        { text: "Número do Relatório", value: "relatorio.numero" },
        { text: "Total de Relatórios", value: "relatorio.total" },
        { text: "Código da Contratação", value: "relatorio.codigoContratacao" },
        { text: "Perídodo da Realização", value: "relatorio.horasTarefas" },
      ],
      headers: [
        { text: "Título", value: "relatorio.titulo" },
        { text: "Município", value: "relatorio.municipio.nome" },
        { text: "Criado por", value: "relatorio.usuario.nome" },
        { text: "Criado em", value: "relatorio.criacao" },
      ],
      headersTarefas: [
        { text: "Tarefa", value: "municipioTarefa.nome" },
        { text: "Cumprida", value: "cumprida" },
        {
          text: "Evidências",
          value: "tarefa.municipioTarefa.municipioEvidencias",
        },
      ],
      headersConvidados: [
        { text: "Nome", value: "convidado.nome" },
        { text: "CPF", value: "convidado.cpf" },
        { text: "E-mail", value: "convidado.email" },
        { text: "Presente", value: "presente" },
      ],
      headersAnexos: [
        { text: "Nome", value: "nome" },
        { text: "", value: "download" },
      ],
      headersAdministrativeReport: [
        {
          text: "#",
          value: "relatorioAdministrativo.relatorioAdministrativoId",
        },
        {
          text: "Título",
          value: "relatorioAdministrativo.titulo",
        },
        {
          text: "Município",
          value: "relatorioAdministrativo.municipio.nome",
        },
        {
          text: "Criador",
          value: "relatorioAdministrativo.usuario.nome",
        },
        {
          text: "Horas",
          value: "relatorioAdministrativo.horas",
        },
      ],
      report: {},
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    save(statusId) {
      if (statusId === 2 && !this.report.observacoes) {
        this.$notification.error("Favor inserir o motivo da rejeição");
      } else {
        this.setLoading(true);
        this.payload.statusId = statusId;
        this.payload.aprovadorId = this.user.usuarioId;
        let relatorio = this.payload;
        relatorio.relatorioPagamento = null;
        relatorio.relatorioAdministrativoPagamento = null;
        relatorio.anexos = null;
        relatorio.relatorios = null;
        relatorio.relatoriosAdministrativos = null;
        relatorio.numero = this.report.numero;
        relatorio.total = this.report.total;
        relatorio.codigoContratacao = this.report.codigoContratacao;
        relatorio.periodoRealizacao = this.report.periodoRealizacao;
        relatorio.observacoes = this.report.observacoes;
        paymentReportManagementAPI
          .analyse(relatorio)
          .then((resp) => {
            this.setLoading(false);
            this.$emit("onCloseReport", true);
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error("Erro ao atualizar relatório");
          });
      }
    },
    downloadAnexo(evidencia) {
      paymentReportManagementAPI
        .downloadAnexo(evidencia.relatorioAnexoId)
        .then((resp) => {
          let blob = new Blob([resp.data], {
            type: resp.headers["content-type"],
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = evidencia.nome;
          link.click();

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter Anexo");
        });
    },
    downloadAnexoProcessoPagamento(anexo) {
      paymentReportManagementAPI
        .downloadAnexoProcessoPagamento(anexo.relatorioGestaoPagamentoAnexoId)
        .then((resp) => {
          let blob = new Blob([resp.data], {
            type: resp.headers["content-type"],
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = anexo.nome;
          link.click();

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter Anexo");
        });
    },
    get() {
      this.setLoading(true);
      paymentReportManagementAPI
        .get(this.payload.relatorioGestaoPagamentoId)
        .then((resp) => {
          this.report = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter processo de pagamento");
        });
    },
  },
  computed: {
    ...mapGetters(["isAdmin", "user", "isAT"]),
  },
  watch: {
    dialog(value) {
      if (value) {
        this.get();
      }
    },
  },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
